
import tableAppDynamicProviderTokens from "./tableAppDynamicProviderTokens";

export default {
  title: 'V.T. Dynamic provider Tokens',
  attributeName: 'appDynamicProviderTokens',
  getURL: 'appId/appDynamicProvider/id/tokens',
  updateURL: 'appId/appDynamicProvider/id/tokens',
  removeURL: 'appId/appManualProvider',
  sessionParams: ['appId'],
  idAttribute: 'providerId',
  tableConfig: tableAppDynamicProviderTokens,
  autoUpdate: true,
  noArea: true,
  goBack: true,
  updateValuesAfterUpdate: ['trackingStatus', 'used'],
  //TODO
  //exportAction: 'appId/appDynamicProvider/id/tokens/export',
  //exportHelp: 'Export the token list',
  //exportName: 'DynamicProviderTokens.xlsx',
};
